import { useEffect, useState } from "react";
import * as configUtils from "util/config";

export const useDDJJEnabledServiceStatement = () => {
    const [enabledStatements, setEnabledStatements] = useState({});

    useEffect(() => {
        setEnabledStatements({
            II1: configUtils.getBoolean("comex.ddjj.services.II1.enabled"),
            II2: configUtils.getBoolean("comex.ddjj.services.II2.enabled"),
            II3: configUtils.getBoolean("comex.ddjj.services.II3.enabled"),
            II4: configUtils.getBoolean("comex.ddjj.services.II4.enabled"),
            II5: configUtils.getBoolean("comex.ddjj.services.II5.enabled"),
            II6: configUtils.getBoolean("comex.ddjj.services.II6.enabled"),
            II7: configUtils.getBoolean("comex.ddjj.services.II7.enabled"),
            II8: configUtils.getBoolean("comex.ddjj.services.II8.enabled"),
        });
    }, []);

    return { enabledStatements };
};

export default useDDJJEnabledServiceStatement;
